import { Skeleton } from "@/components/ui/skeleton"

export default function NewsSkeleton() {
  const titleWidths = ["w-3/4", "w-2/4", "w-2/3"]

  return (
    <>
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className="py-2.5 flex items-center gap-3">
          <div className="w-18 h-15 shrink-0">
            <Skeleton className="w-full h-full rounded-xl" />
          </div>
          <div className="flex flex-col flex-1 gap-2 text-start">
            <div className="space-y-1">
              <Skeleton className={`h-4 ${titleWidths[index]}`} />
            </div>

            <Skeleton className="w-1/4 h-3" />
          </div>
        </div>
      ))}
    </>
  )
}
